module.exports = "<div class=\"contenedor\">\n  <img [src]=\"info.imgUrl\" class=\"fondo\">\n</div>"